(function () {
  const slider = document.querySelector('.swiper');
  if (slider) {
    const swiper = new Swiper('.swiper', {
      spaceBetween: 11,
      slidesOffsetAfter: 30,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          slidesOffsetAfter: 30,
        },
        768: {
          slidesPerView: 2.2,
          // slidesOffsetBefore: 140,
          slidesOffsetAfter: 140,
        },
        1140: {
          slidesPerView: 3.75,
          // slidesOffsetBefore: 250,
          slidesOffsetAfter: 250,
        },
        1536: {
          slidesPerView: 4.75,
          // slidesOffsetBefore: 350,
          slidesOffsetAfter: 350,
        },
      },
    });
  }
})();
